import React from "react";
import './customView.scss';
export default class CustomView extends React.Component<any, any>{
    render() {
            return(
                    <div className="page-image-container">
                        <div className="page-heading">{"Custom View"}</div>
                    </div>
        )
    }

}